module.exports = __webpack_public_path__ + "static/media/mk3.41a33341.png";